//libs
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
//Utils
import { ApiServiceV2 } from 'services';
// Components
import { LogoIcon, SyncIcon, Wrapper } from 'components';
// Hooks
import { useToastMessage } from 'hooks';
// Actions
import { reloadDatasource } from 'core/actions';

const Sync = ({ rowData }) => {
	const dispatch = useDispatch();
	const sendToast = useToastMessage();

	const [state, _setState] = useState({
		isLoading: false,
	});

	const setState = newState =>
		_setState(current => ({ ...current, ...newState }));

	const handdlesync = () => {
		setState({ isLoading: true });

		ApiServiceV2.post({
			url: `/paycuts/sync`,
			data: { paycut_id: rowData.id },
		})
			.then(() => {
				sendToast({ message: 'Corte de Pago Actualizado', type: 'success' });
				setState({ isLoading: false });
				dispatch(reloadDatasource());
			})
			.catch(err => {
				sendToast({ message: err.message, type: 'error' });
				setState({ isLoading: false });
			});
	};

	return (
		<Wrapper padding='0'>
			{rowData.state === 'ready' || rowData.state === 'released' ? (
				state.isLoading ? (
					<LogoIcon spin button />
				) : (
					<SyncIcon button onClick={handdlesync} />
				)
			) : (
				<div />
			)}
		</Wrapper>
	);
};

export default Sync;
